export default {"mode":"ios","animated":false}